import { Pipe, PipeTransform } from '@angular/core';
import { formatPhoneNumber } from '@shared/utils/phone-number.util';

@Pipe({
  name: 'phoneNumber',
  standalone: true
})
export class PhoneNumberPipe implements PipeTransform {
  transform(value: string, notDisplay?: boolean): string {
    return formatPhoneNumber(value, notDisplay)
  }
}
